export const LOGIN = {
  vgem: { email: 'vgemhost@gmail.com', password: 'underconstruction' },
  gem30host: { email: 'vgemhost@mail.com', password: 'vgem2021host' },
  gem30: { email: 'vgemperson@gmail.com', password: 'vgem2021' },
}

export const PASSWORD = 'yV$#-m@23nM+kQWn'
